import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { ChancenwerkUser } from '@chancenwerk/shared/master-data-management/users/entities/ChancenwerkUser.js';
import { DateTime } from 'luxon';
import type { MarktAkquiseStatus } from './MarktAkquiseStatus.js';

/**
 * @entity MarktAkquiseContactRecord
 */
@Entity()
export class MarktAkquiseContactRecord extends AdornisEntity {
  public static override _class = 'MarktAkquiseContactRecord';

  public static override resolveID(entity: any): string {
    return A.getGloballyUniqueID();
  }

  @Field(() => String)
  fromID: Maybe<string>;

  @DataLoadedField(() => ChancenwerkUser, ({ fromID }) => fromID)
  from: Maybe<ChancenwerkUser>;

  @Field(() => String)
  toID: Maybe<string>;

  @DataLoadedField(() => ChancenwerkUser, ({ toID }) => toID)
  to: Maybe<ChancenwerkUser>;

  @Field(() => DateTime)
  when: Maybe<DateTime>;

  @Field(() => String)
  response: Maybe<string>;

  @Field(() => String)
  nextStep: Maybe<string>;

  @Field(() => DateTime)
  nextStepWhen: Maybe<DateTime>;

  @Field(() => String)
  status: Maybe<MarktAkquiseStatus>;
}
